import { all, call } from 'redux-saga/effects';

import { fetchPicturesStart } from './picture/picture.sagas';
import { fetchMusicStart } from './music/music.sagas';

export default function* rootSaga() {
    yield all([call(fetchPicturesStart), call(fetchMusicStart)]);
}
